import {
    Button,
    Badge,
    Typography
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useInput, useRecordContext } from "ra-core";
import { CommonInputProps } from "react-admin";
import FilePreview from "./FilePreview";
import { FileInputModal, FileInputModalProps } from "./FileInputModal";

export type FileInputProps = CommonInputProps & {
    multiple?: boolean;
    fileTypes?: string[];
    path?: string;
    inputType?: "file" | "image" | "document";
    preview?: boolean;
    previewWidth?: string;
    label?: string;
    includeDomain?: boolean;
    lockPath?: boolean;
};

export const FileInput = (props: FileInputProps) => {
    const { 
        source, 
        defaultValue,
        fileTypes=["JPG", "JEPG", "GIF", "PNG", "SVG", "WEBP", "MP4"],
        multiple=true,
        path = "admin/media",
        inputType = "image",
        preview = true,
        previewWidth = "100%",
        label,
        includeDomain = false,
        lockPath = false    
    } = props;
    
    const { field } = useInput({ ...props, source, defaultValue });
    const record = useRecordContext();
    const [paths, setPaths] = useState<string[]>([]);

    const fileInputModalRef = useRef<any>();
    
    const modalProps:FileInputModalProps =  {
        multiple:multiple,
        path: path,
        fileTypes:fileTypes,
        paths: paths,
        setPaths: setPaths,
        includeDomain: includeDomain,
        lockPath: lockPath
    }

    const openModal = () => {
        const currentRef = fileInputModalRef.current;
        if (currentRef) {
            currentRef.handleOpen()
        }
    };

    useEffect(() => {
        setPaths(typeof record !== 'undefined' && typeof record[source] !== 'undefined' &&  record[source] !== null ? record[source].split(", ") :  []);
    }, [record]);

    useEffect(() => {
        field.onChange(paths.length > 0 ? paths.join(", "): "")
    }, [paths]);

    const getButtonText = () =>
        `${paths && paths.length ? "Change" : "Add"} ${inputType}${multiple ? "s" : ""
        }`;

    return (
        <React.Fragment>

            {label ? <Typography sx={{paddingBottom: "10px"}}>{label}</Typography> : null}
            
            <FileInputModal ref={fileInputModalRef} {...modalProps}></FileInputModal>

            {preview ? <FilePreview paths={paths} setPaths={setPaths} width={previewWidth}/> : null}

            <Badge color="primary" badgeContent={paths.length} overlap="rectangular" sx={{marginBottom: "24px"}}>
                <Button variant="outlined" onClick={openModal}>
                    {getButtonText()}
                </Button>
            </Badge>

        </React.Fragment>
    );
};




